import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

/** Utilidades de data no fuso do negócio. Dias como "yyyy-MM-dd". */
export const dayOf = (d: Date | string, tz: string) => formatInTimeZone(new Date(d), tz, 'yyyy-MM-dd');
export const timeOf = (d: Date | string, tz: string) => formatInTimeZone(new Date(d), tz, 'HH:mm');
export const atLocal = (day: string, hhmm: string, tz: string) => fromZonedTime(`${day}T${hhmm}:00`, tz);
export const startOfDayIso = (day: string, tz: string) => atLocal(day, '00:00', tz).toISOString();
export const endOfDayIso = (day: string, tz: string) => new Date(atLocal(shiftDay(day, 1), '00:00', tz).getTime() - 1).toISOString();
export function shiftDay(day: string, n: number): string {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d! + n)).toISOString().slice(0, 10);
}
export function weekdayOf(day: string): number {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d!)).getUTCDay();
}
/** Segunda-feira da semana do dia. */
export const startOfWeek = (day: string) => shiftDay(day, -((weekdayOf(day) + 6) % 7));
export const startOfMonth = (day: string) => day.slice(0, 8) + '01';
export function daysInMonth(day: string): number {
  const [y, m] = day.split('-').map(Number);
  return new Date(Date.UTC(y!, m!, 0)).getUTCDate();
}
export const minutesOf = (hhmm: string) => { const [h, m] = hhmm.split(':').map(Number); return (h ?? 0) * 60 + (m ?? 0); };
export const fmtDay = (day: string, locale: string, opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...opts }).format(new Date(day + 'T12:00:00Z'));
export const fmtDateTime = (d: string | Date, tz: string, locale: string, opts: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) => new Intl.DateTimeFormat(locale, { timeZone: tz, ...opts }).format(new Date(d));
export const todayIn = (tz: string) => dayOf(new Date(), tz);
export const toLocalInput = (d: Date | string, tz: string) => formatInTimeZone(new Date(d), tz, "yyyy-MM-dd'T'HH:mm");
/** Valor de um <input type="datetime-local"> ("yyyy-MM-ddTHH:mm") interpretado no fuso do negócio, em ISO UTC. */
export const localToIso = (v: string, tz: string) => fromZonedTime(v, tz).toISOString();
